import { isEnv } from '@nackle/game-loader-comm-api';
import CONFIG from 'app/config';
import { stopPlayingRom } from 'app/dux/play/actions';
import { getRomBeingPlayed } from 'app/dux/play/selectors';
import { getSessionId } from 'app/dux/session/selectors';
import { gameLoaderHtml, IMG_AWARD_SWIRL } from 'assets/game-loader-assets';
import { GameLoaderBridge } from 'components/gameLoaderBridge/GameLoaderBridge';
import noop from 'lodash/noop';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { AppState } from 'app/store/reducers';

const mapStateToProps = () => {
    const getSessionGetter = createSelector(
        getSessionId,
        (accessToken: string) => {
            return () => accessToken;
        }
    );

    const env = CONFIG.ENV;
    if (!isEnv(CONFIG.ENV)) {
        throw Error(`${CONFIG.ENV} is not a valid environment ID.`);
    }

    return (state: AppState) => {
        const romId = getRomBeingPlayed(state);
        if (!romId) {
            return {};
        }

        return {
            env,
            loaderUrl: gameLoaderHtml,
            onPlay: async () => ({ rewards: [{ type: 'POINTS', value: '100.0' }] }),
            rewards: [],
            romId: state.play.playingRomId,
            gameplayUpdate: noop,
            getSession: getSessionGetter(state),
            imageUrls: { IMG_AWARD_SWIRL },
        };
    };
};

const mapDispatchToProps = {
    onClose: stopPlayingRom,
};

export default connect(mapStateToProps, mapDispatchToProps)(GameLoaderBridge);
